import { checkSubscription } from "../helpers/subscriptionProvider";
import checkMarkImg from "../assets/check-mark.svg";
import { strings } from "constants/strings";
import React, { Component } from "react";
import { PostExerciseBadges } from './Badges'

export default class GameOver extends Component {
  render() {
    let devicesImg = '/react/images/qr/one_link_qr.png'
    const isActive = checkSubscription();//useSubscriptionContext();
    return (
      <div key="gameOver" className="game-over">
        <div className="gameOver-inner">
          <img
            src={checkMarkImg}
            width="60"
            className="times-up-img"
            alt="Green Check Mark"
          />
          <div className="post-ex-head">{this.props.title}</div>
          {this.props.children && this.props.children}
          {!this.props.children && (
            <>
              <div className='caption'
                style={{ fontSize: "24px" }}
                dangerouslySetInnerHTML={{ __html: strings.Postexercise_scoretitle }}
              ></div>
              <div className="score"
                style={
                  {
                    margin: '-20px auto 20px'
                  }
                }
              >{Math.floor(this.props.points)}</div>
            </>
          )}
          {!isActive && (
            <>
              <div
                style={{ fontSize: "16px" }}
                dangerouslySetInnerHTML={{ __html: strings.Postexercise_free_text1 }}
              ></div>
              <a id={this.props.analyticsActions.btnPremium}
                href={strings.Web_prices_link}
                style={{ fontSize: "24px" }}
                className="ex-button yellow"
              >
                {strings.Subscription_Premium_Title}
              </a>
            </>
          )}
          {isActive ?
            <>
              <div
                style={{ fontSize: "16px", margin: "0px auto", width: "83%" }}
                dangerouslySetInnerHTML={{ __html: strings.Postexercise_premium }}
              >
              </div>
              <div className="res-down-block">

                <div>
                  <img style={{
                    maxWidth: "200px",
                    margin: "0 40px 0 0",
                  }} src={devicesImg} alt="" />
                </div>
                <PostExerciseBadges
                  btnAmazonId={this.props.analyticsActions.btnAmazon}
                  btnGoogleId={this.props.analyticsActions.btnGoogle}
                  btnAppleId={this.props.analyticsActions.btnApple}
                />
              </div>
            </>
            : ''
          }
        </div>
      </div>
    );
  }
}
